import { inject, Injectable, Injector } from '@angular/core';
import { authLog } from 'src/app/auth/auth.handler';
import { AppSettings } from 'src/app/core/common/app.settings';
import { Auth } from 'src/app/core/common/auth';

@Injectable()
export class Initializer {
  private settings = inject(AppSettings);
  private injector = inject(Injector);
  public async init() {
    const auth = this.injector.get(Auth);

    return Promise.all([
      auth.checkAuth().then(() => {
        authLog(`auth.flow::=>initializer.auth.checkAuth: completed`);
      }),
      this.settings.initLanguage().then(() => {
        authLog(`auth.flow::=>initializer.settings.initLanguage: completed`);
      }),
    ])
      .then(async () => {
        authLog(`auth.flow::=>initializer: completed auth & settings initialization`);
        /* Currently not supported on agency api
        const configs = this.injector.get(Configs);
        await firstValueFrom(configs.loadConfigs());

        const tracker = this.injector.get(ErrorTracker);
        tracker.init(); */
      })
      .then(() => {
        authLog(`auth.flow::=>initializer.init: completed`);
      });
  }
}
